import {
  IServiceRequestCreateAction,
  IServiceRequestCreateSuccessAction,
  IServiceRequestCreateErrorAction,
} from '../actions/create-request'
import {createAsyncReducer} from '@telstra-connect/standard-actions/reducers'
import {initialState} from '../state/initial-state'
import {IMobilityState} from '../state'

export type RequestsAction =
  | IServiceRequestCreateAction
  | IServiceRequestCreateSuccessAction
  | IServiceRequestCreateErrorAction

const init = (state: IMobilityState) => ({
  ...state,
  createServiceRequest: initialState.createServiceRequest,
})

const success = (state: IMobilityState, action: RequestsAction) => ({
  ...state,
  createServiceRequest: {
    data: (action as IServiceRequestCreateSuccessAction).data,
    status: action.status,
    requestActionType: (action as IServiceRequestCreateSuccessAction).requestActionType,
  },
})

const reset = (state: IMobilityState) => ({
  ...state,
  createServiceRequest: initialState.createServiceRequest,
})

const failure = (state: IMobilityState, action: RequestsAction) => ({
  ...state,
  createServiceRequest: {
    status: action.status,
    error: (action as IServiceRequestCreateErrorAction).error,
    requestActionType: (action as IServiceRequestCreateErrorAction).requestActionType,
  },
})

export const createServiceRequestReducer = createAsyncReducer(
  initialState,
  init,
  success,
  failure,
  reset,
)
